var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75349 16.5L0.332899 9.19534C0.106091 8.93464 -0.0124259 8.59928 0.00103248 8.2563C0.0144908 7.91331 0.158933 7.58795 0.405494 7.34524C0.652055 7.10254 0.982575 6.96035 1.331 6.9471C1.67944 6.93385 2.02011 7.05052 2.28496 7.27378L7.75349 12.6024L19.715 0.827696C19.9799 0.604432 20.3206 0.487768 20.669 0.501016C21.0174 0.514264 21.3479 0.656449 21.5945 0.899158C21.8411 1.14187 21.9855 1.46722 21.999 1.81021C22.0124 2.1532 21.8939 2.48855 21.6671 2.74926L7.75349 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVector);
export default __webpack_public_path__ + "static/media/CheckVector.7a7ee19d28bedb018bb5cfa19ba6efd9.svg";
export { ForwardRef as ReactComponent };